import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { FiChevronDown } from "react-icons/fi";

export const serviceLinks = [
  ["/privacy", "Privacy"],
  ["/terms", "Voorwaarden"],
  ["/cookies", "Cookiebeleid"],
  ["/faqs", "FAQs"],
  ["/shipping", "Verzending"],
  ["/returns", "Retourneren"],
];

function MoreMenu({ mobile = false }) {
  const [open, setOpen] = useState(false);
  const wrapper = useRef(null);
  const trigger = useRef(null);
  const location = useLocation();
  const id = mobile ? "mobile-more-links" : "header-more-links";

  useEffect(() => setOpen(false), [location.pathname, location.search]);
  useEffect(() => {
    if (!open) return undefined;
    const closeOutside = (event) => {
      if (!wrapper.current?.contains(event.target)) setOpen(false);
    };
    const closeEscape = (event) => {
      if (event.key === "Escape") {
        setOpen(false);
        trigger.current?.focus();
      }
    };
    document.addEventListener("pointerdown", closeOutside);
    document.addEventListener("keydown", closeEscape);
    return () => {
      document.removeEventListener("pointerdown", closeOutside);
      document.removeEventListener("keydown", closeEscape);
    };
  }, [open]);

  return (
    <div ref={wrapper} className={`more-menu${mobile ? " more-menu--mobile" : ""}`}
      onBlur={(event) => {
        if (!event.currentTarget.contains(event.relatedTarget)) setOpen(false);
      }}>
      <button ref={trigger} type="button" aria-expanded={open} aria-controls={id}
        onClick={() => setOpen((value) => !value)}>
        More <FiChevronDown aria-hidden="true" />
      </button>
      {open && <div id={id} className="more-menu__links">
        {serviceLinks.map(([to, label]) => <Link key={to} to={to} onClick={() => {
          setOpen(false);
          window.scrollTo({ top: 0, behavior: "smooth" });
        }}>{label}</Link>)}
      </div>}
    </div>
  );
}

export default MoreMenu;
